<script setup>
import { isTpad } from "@common/utils";

const listeners = useListeners();
const emit = defineEmits();
const props = defineProps({
  dark: [Boolean, Number],
  disable: [Boolean, Number],
  selected: [Boolean, Number],
});

const classMap = computed(() => ({
  // "nio-radio": true,
  "nio-radio-show":true,
  // "nio-radio-pad": isTpad,
  "nio-dark": props.dark,
  "nio-disable": props.disable,
  "nio-selected": props.selected,
}));
</script>

<template>
  <div class="nio-radio" :class="{'nio-radio-wrap':isTpad}" @click.stop="!disable && emit('click')">
    <div :class="classMap" >
      <nio-icon type="check" />
    </div>
  </div>
</template>

<style lang="scss" scoped>

.nio-radio {
  @include flex-center;
  @include transition;
  width: rem(20);
  height: rem(20);  
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  color: transparent;
}
.nio-radio-wrap{
 padding: 10px 0 0 10px;
//  box-sizing: border-box
}
.nio-radio-show {
  @include flex-center;
  border: 1px solid $color-l3;
  box-sizing: border-box;
  border-radius: 50%;
  width: rem(20);
  height: rem(20);
  // border-radius: 9999;

  .nio-icon {
    width: 100%;
    height: 100%;
  }

  &:hover {
    border-color: $color-l1;
  }

  // 选中 + 按下
  .nio-selected &,
  &.nio-selected
  // &:active 
  {
    color: #fff;
    border-color: transparent; // 透明后就和底色一致
    background-color: #01030d;

    // 深色模式下选中
    .nio-dark &,
    &.nio-dark {
      color: $color-l1;
      background-color: #fff;
    }
  }

  // 深色模式
  .nio-dark &,
  &.nio-dark {
    border-color: rgba(255, 255, 255, 0.5);

    &:hover {
      border-color: rgba(255, 255, 255, 0.8);
    }
  }

  // 禁用
  .nio-disable &,
  &.nio-disable {
    border-color: $color-l4 !important;
    background-color: #f7f7f8 !important;

    // 深色模式下禁用
    .nio-dark &,
    &.nio-dark {
      border-color: rgba(255, 255, 255, 0.2) !important;
      background-color: rgba(255, 255, 255, 0.1) !important;
    }
  }
}
.nio-radio-pad {
  width: 24px;
  height: 24px;
  .nio-icon {
    width: 60%;
    height: 60%;
  }
}
</style>
